/**
 * Created by manuel on 11/15/16.
 */
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { ContactsResponse } from 'src/app/model/contact.class';

import { SessionService } from '../shell/session.service';
import { SubscriptionResponse, SubscriptionService } from '../shell/subscription.service';
import { ContactListService } from './contact-list.service';

@Injectable()
export class ContactListResolve implements Resolve<[SubscriptionResponse, ContactsResponse]> {
  constructor(
    private contactListService: ContactListService,
    private subscriptionService: SubscriptionService,
    private session: SessionService
  ) {}

  resolve(): Observable<[SubscriptionResponse, ContactsResponse]> {
    return forkJoin([
      this.subscriptionService.getSubscription(),
      this.contactListService.getContacts(this.session.current.pbxId),
    ]);
  }
}
